module.exports = function isNumeric(obj){return !isNaN(parseFloat(obj)) && isFinite(obj);};


/*****************
 ** WEBPACK FOOTER
 ** ./lib/isNumeric.js
 ** module id = 21
 ** module chunks = 0
 **/